import { lazy } from 'react';
import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const WaitingRoomPage = lazy(() => import('./pages/WaitingRoom'));
const DisputesPage = lazy(() => import('./pages/Disputes'));
const DisputeDetailPage = lazy(() => import('./pages/DisputeDetail'));
const RegistrationsPage = lazy(() => import('./pages/Registrations'));
const BiometricBlocksPage = lazy(() => import('./pages/BiometricBlocks'));
const FinesPage = lazy(() => import('./pages/Fines'));

/** Perfil suporte (T-58..T-62) — dentro do módulo do gestor, separado por permissões (regras-gestor §1). */
const support = (el: ReactNode) => <RequireAuth roles={['SUPPORT']}>{el}</RequireAuth>;

const routes: RouteObject[] = [
  { path: '/suporte', element: support(<WaitingRoomPage />) },
  { path: '/suporte/questionamentos', element: support(<DisputesPage />) },
  { path: '/suporte/questionamentos/:id', element: support(<DisputeDetailPage />) },
  { path: '/suporte/cadastros', element: support(<RegistrationsPage />) },
  { path: '/suporte/biometria', element: support(<BiometricBlocksPage />) },
  { path: '/suporte/biometria/:patientId', element: support(<BiometricBlocksPage />) },
  { path: '/suporte/multas', element: support(<FinesPage />) },
];
export default routes;
